import { useState } from "react";
import ContactFormSection from "../Components/ContactFormSection";

const faqs = [
  {
    q: "What is an OM (Offering memorandum)",
    a: [
      "An Offering Memorandum (OM) is a comprehensive document that provides investors with all the necessary information to make informed decisions about purchasing or leasing properties. It typically includes detailed descriptions, financial data, and other relevant information about the properties.",
    ],
  },
  {
    q: "Improve on this question: What is the CAP rate (Capitalization Rate)?",
    a: [
      "The CAP rate, or Capitalization Rate, is a metric used to evaluate the potential return on investment in real estate. It is the return on your cash investment. It is expressed in percentage.",
      "Imagine you own a property, and you collect rent from tenants. After you pay all the expenses needed to maintain the property, like taxes, insurance, and maintenance/repairs, the money left over is called the Net Operating Income (NOI).",
      "The CAP rate is a way to see how good an investment the property is by comparing this leftover money (NOI) to the property's current value or purchase price.",
      "In simpler terms, it shows how much income a property generates compared to its value. A higher CAP rate generally means a better return on investment, but it might also come with more risk. A lower CAP rate usually indicates a more stable investment with lower returns.",
      "Think of the CAP rate as a way to measure how efficiently a property is making money relative to its cost.",
      "If you have the annual Net Operating Income (NOI) and the purchase price, you can calculate the CAP rate of the property by dividing the annual NOI by the property's purchase price.",
      "If you have the purchase price and the CAP rate, you can calculate the annual Net Operating Income (NOI) of the property by multiply the property's purchase price with CAP rate.",
    ],
  },
  {
    q: "What is NNN Lease and What is Absolute NNN Lease?",
    a: [
      "A Triple Net Lease (NNN) is a type of commercial real estate lease agreement where the tenant agrees to pay not only the base rent but also all the operating expenses associated with the property.",
      "Key Points of a Triple Net Lease (NNN):",
      "Base Rent: The tenant pays a base rent to the landlord.",
      "Operating Expenses: The tenant is responsible for paying property taxes, building insurance, and all maintenance and repair costs associated with the property.",
      "Pros for landlords:",
      "Steady and consistent revenue stream.",
      "Transfer of utility expenses, repair costs, taxes, and property management to the tenant.",
      "Protects the landlord against increase in taxes, insurance and maintenance costs.",
      "An Absolute Triple Net Lease (Absolute NNN) is a type of commercial real estate lease agreement where the tenant is responsible for paying property taxes, building insurance, and all maintenance and repair costs associated with the property including structural problems such as replacement of roof.",
    ],
  },
  {
    q: "Who Pays Sales Tax On The Rent Payments",
    a: [
      "In most cases, the tenant is responsible for paying the sales tax on commercial leases. The landlord typically collects the sales tax along with the rent and then remits it to the appropriate tax authority. This is common practice in states that impose sales tax on commercial leases, such as Florida.",
      "However, the specifics can vary depending on the lease agreement and local regulations. It's always a good idea to review the lease terms and consult with a tax professional or legal advisor to understand the obligations in your particular state.",
    ],
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="section-wrap py-10 lg:py-14">
      <section className="grid gap-6 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)]">
        <article className="premium-panel p-7 sm:p-10">
          <h1 className="mt-3 font-serif text-4xl text-obsidian-950">FREQUENTLY ASKED QUESTIONS</h1>
          <div className="mt-8 space-y-3">
            {faqs.map((item, index) => {
              const open = index === openIndex;

              return (
                <div key={item.q} className="rounded-2xl border border-obsidian-200 bg-cream-50">
                  <button
                    type="button"
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                  >
                    <span className="text-sm font-semibold text-obsidian-900">{item.q}</span>
                    <span className="text-lg text-obsidian-700">{open ? "▾" : "▸"}</span>
                  </button>
                  {open ? (
                    <div className="border-t border-obsidian-200 px-4 py-4 text-sm leading-7 text-obsidian-700">
                      {item.a.map((paragraph) => (
                        <p key={paragraph} className="mb-3 last:mb-0">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </article>

        <aside>
          <ContactFormSection
            title="CONTACT FORM"
            className="xl:sticky xl:top-28"
          />
        </aside>
      </section>
    </div>
  );
}

export default FAQ;
